// 문자 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import logHelper from './logHelper';

// =================================================================================================
// 상수
// =================================================================================================
// object to string
const valueOfObject = (aObject) => {
  let s1;
  try {
    s1 = JSON.stringify(aObject); // string 화
  } catch (e) {
    logHelper.error(e);
  }
  return s1;
};

const toLowerCase = (sTarget) => {
  return sTarget.toLowerCase();
};

const substring = (sTarget, iStart, iEnd) => {
  return sTarget.substring(iStart, iEnd);
};

const isNullOrEmpty = (sTarget) => {
  if (sTarget == null) {
    return true;
  }
  if (sTarget == '') {
    return true;
  }

  return false;
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  isNullOrEmpty,
  substring,
  toLowerCase,
  valueOfObject,
};
